import { motion } from "framer-motion";
import { PROJECTS } from "@/constants/siteData";

export const ProjectArchive = () => {
  return (
    <section id="archive" className="theme-void relative bg-background py-24 sm:py-32">
      <div className="container-xl">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <span className="eyebrow-mono">// Now Producing</span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-foreground sm:text-4xl lg:text-5xl">
            Titles in Development
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            Three feature-length documentaries currently moving through
            production.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-1 border-2 border-foreground/80 md:grid-cols-3 md:divide-x-2 divide-y-2 md:divide-y-0 divide-foreground/80">
          {PROJECTS.map((project, idx) => (
            <motion.article
              key={project.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              className="group flex flex-col"
            >
              <div className="relative aspect-[4/5] overflow-hidden border-b-2 border-foreground/80">
                <img
                  src={project.image}
                  alt={project.title}
                  className="absolute inset-0 h-full w-full object-cover grayscale transition-transform duration-700 ease-smooth group-hover:scale-[1.04]"
                />
              </div>
              <div className="flex flex-1 flex-col p-6 sm:p-8">
                <span className="eyebrow-mono">{project.category}</span>
                <h3 className="mt-3 font-display text-2xl font-semibold leading-tight text-foreground sm:text-[1.7rem]">
                  {project.title}
                </h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">
                  {project.logline}
                </p>
                <span className="mt-6 inline-flex w-fit items-center border-2 border-foreground/70 px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-foreground/85">
                  {project.status}
                </span>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
